export default "__VITE_ASSET__DMc5jkDm__"